import React from 'react';
import style from './ModuleEncartMtCustom.scss';
import { Link } from 'react-router-dom';
import * as icones from '../Icones'
import * as tools from '../Tools';
import isExternal from 'is-url-external';

const Fleche = ({ color }) => color == 'rouge' ? <icones.fleche /> : <icones.flecheRouge />

export class ModuleEncartMtCustom extends React.Component {
	icone(nomIcone) {
		return (
			<img
				src={nomIcone}
				style={{
					width: '120px',
					position: 'absolute',
					zIndex: '2',
					top: '50%',
					left: '50%' /* à 50%/50% du parent référent */,
					transform:
						'translate(-50%, -50%)' /* décalage de 50% de sa propre taille */
				}}
			/>
		);
	}

	// checkFleche(color) {
	// 	if (color == 'rouge') {
	// 		return <icones.flecheRouge />
	// 	} else {
	// 		return <icones.fleche />
	// 	}
	// }

	content() {
		const { element } = this.props;
		return (
			<div
				className={style.moduleEncart}
				style={{ borderRadius: '10px' }}
			>
				<div
					className={style.moduleEncartMtTitre}
					style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px', backgroundColor: element.couleurTitre || '#7cb4d7' }}
				>
					{/* *** titre *** */}
					<h4 className="text-center pt-2 ft-lato text-white" style={{ fontSize: '1.2rem' }}>
						{element.titre}
					</h4>
					{/* ******************** */}

					{/* *** image *** */}
					<div
						className={" " + style.encartContenuImage}
						style={{ position: 'relative' }}
					>
						<div className="align-self-center" style={{ margin: '0 auto' }}>
							{this.icone(element.iconSrc)}
						</div>
						<div
							className={" " + style.encartFleche}
							style={{
								zIndex: '5',
								position: 'absolute',
								marginTop: '-1px',
								borderTop: '15px solid ' + element.couleurTitre || '#7cb4d7'
							}}
						/>
						<img
							src={`${tools.lienPhotos}/${element.imgSrc}`}
							className={"img-fluid " + style.encartImage}
							style={{ filter: 'brightness('+ element.brightness || 70 +'%)', zIndex: '1' }}
						/>
					</div>



				</div>
				{/* ********************** */}
				<div
					// className={style.moduleEncart}
					style={{ border: '0px solid #fff', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px', backgroundColor: '#fff' }}
				>
					<div style={{ zIndex: '10' }}>
						<h5
							className="pl-4 pr-4 pt-4 ft-alegreya-sans-medium"
							style={{ color: '#333' }}
						>
							{element.sousTitre}
						</h5>
						<div className="pl-4 pr-4 text-justify">
							{element.contenu}
							{/* Bloc Lire la suite */}
							{!element.lireLaSuiteHidden && (
								<div
									className="ml-1 ft-lato-light pb-4"
									style={{ color: '#333', fontSize: '1.2em' }}
								>
									<icones.flecheCouleur width={25} couleur={element.couleurTitre} />

									&nbsp;&nbsp;{element.textLink || "Lire la suite"}
								</div>
							)}
							{element.lireLaSuiteHidden && (
								<p className="pb-2"></p>
							)}
							{/* ********************************** */}

						</div>
					</div>
				</div>
			</div>
		)
	}

	render() {
		const { element } = this.props;



		// taille image : 550 px x 305px

		return (
			<React.Fragment>
				<div className={"col-xl-6 col-md-6 mb-5 block"}>
					{this.content()}
				</div>
			</React.Fragment>
		);
	}
}

